<template>
  <div class="homePage consultPage consultPage_new">
    <Header :type="pageType" />
    <div class="main_page">
      <div class="home_banner">
        <div class="banner_title1">
          专家1对1
          <div class="border_left_banner"></div>
        </div>
        <div class="banner_title2">定制家庭专属保障</div>
        <div class="banner_text1">
          不限次专业咨询，实时量化保障缺口
        </div>
        <div class="banner_qrcode">
          <img src="@/assets/images/versionNew/qrcode_new.jpg" alt="" />
        </div>
      </div>
      <!-- <div class="bx_container publish_bx_container">
        <div class="bx_container_title">
          <div class="main_title">保险咨询服务</div>
        </div>
        <div class="solution_advisers">
          <div class="solution_type">家庭方案配置</div>
          <div class="advisers_list">
            <div v-for="item in solution1" :key="item.id" class="adviser_card">
              <div class="adviser_info_iframe">
                <div class="adviser_info_ab">
                  <div class="adviser_name">
                    <span>{{ item.adviserName }}</span>
                    <div class="adviser_title">{{ item.adviserTitle }}</div>
                  </div>
                  <div class="adviser_cert">
                    <div
                      v-for="identificate in item.identification.split(',')"
                      :key="identificate + item.id"
                      class="cert_item"
                    >
                      {{ identificate }}
                    </div>
                  </div>
                </div>
                <img :src="item.bustPhoto" alt="" class="bust_img_ab" />
              </div>
              <div
                @click="
                  () =>
                    $refs.qrcodeRef.show(servicePath + '?adviser=' + item.id)
                "
                class="adviser_btn"
              >
                付费咨询
              </div>
            </div>
          </div>
        </div>
        <div class="solution_advisers">
          <div class="solution_type">儿童方案配置</div>
          <div class="advisers_list">
            <div v-for="item in solution2" :key="item.id" class="adviser_card">
              <div class="adviser_info_iframe">
                <div class="adviser_info_ab">
                  <div class="adviser_name">
                    <span>{{ item.adviserName }}</span>
                    <div class="adviser_title">{{ item.adviserTitle }}</div>
                  </div>
                  <div class="adviser_cert">
                    <div
                      v-for="identificate in item.identification.split(',')"
                      :key="identificate + item.id"
                      class="cert_item"
                    >
                      {{ identificate }}
                    </div>
                  </div>
                </div>
                <img :src="item.bustPhoto" alt="" class="bust_img_ab" />
              </div>
              <div
                @click="
                  () =>
                    $refs.qrcodeRef.show(servicePath + '?adviser=' + item.id)
                "
                class="adviser_btn"
              >
                付费咨询
              </div>
            </div>
          </div>
        </div>
        <div class="solution_advisers">
          <div class="solution_type">成人方案配置</div>
          <div class="advisers_list">
            <div v-for="item in solution3" :key="item.id" class="adviser_card">
              <div class="adviser_info_iframe">
                <div class="adviser_info_ab">
                  <div class="adviser_name">
                    <span>{{ item.adviserName }}</span>
                    <div class="adviser_title">{{ item.adviserTitle }}</div>
                  </div>
                  <div class="adviser_cert">
                    <div
                      v-for="identificate in item.identification.split(',')"
                      :key="identificate + item.id"
                      class="cert_item"
                    >
                      {{ identificate }}
                    </div>
                  </div>
                </div>
                <img :src="item.bustPhoto" alt="" class="bust_img_ab" />
              </div>
              <div
                @click="
                  () =>
                    $refs.qrcodeRef.show(servicePath + '?adviser=' + item.id)
                "
                class="adviser_btn"
              >
                付费咨询
              </div>
            </div>
          </div>
        </div>
        <div class="solution_advisers">
          <div class="solution_type">老人方案配置</div>
          <div class="advisers_list">
            <div v-for="item in solution4" :key="item.id" class="adviser_card">
              <div class="adviser_info_iframe">
                <div class="adviser_info_ab">
                  <div class="adviser_name">
                    <span>{{ item.adviserName }}</span>
                    <div class="adviser_title">{{ item.adviserTitle }}</div>
                  </div>
                  <div class="adviser_cert">
                    <div
                      v-for="identificate in item.identification.split(',')"
                      :key="identificate + item.id"
                      class="cert_item"
                    >
                      {{ identificate }}
                    </div>
                  </div>
                </div>
                <img :src="item.bustPhoto" alt="" class="bust_img_ab" />
              </div>
              <div
                @click="
                  () =>
                    $refs.qrcodeRef.show(servicePath + '?adviser=' + item.id)
                "
                class="adviser_btn"
              >
                付费咨询
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="bx_container" style="padding-top:110px;">
        <div class="bx_container_title">
          <div class="main_title">骆驼理念</div>
          <div class="sub_title">
            用科学理念辅助保险决策，量身定制专业化投保方案
          </div>
        </div>
        <div class="bx_container_content">
          <div class="ideas">
            <div class="idea_item">
              <div class="idea_title">客观</div>
              <div class="idea_content">
                基于用户视角，分析保险产品的性价比，为用户至少节省30-50%保费
              </div>
            </div>
            <div class="idea_item">
              <div class="idea_title">中立</div>
              <div class="idea_content">
                为用户普及保险知识，科学定制保障规划方案，辅助用户正确进行保险决策
              </div>
            </div>
            <div class="idea_item">
              <div class="idea_title">专业</div>
              <div class="idea_content">
                通过精算、核保、理赔、法律等提供全流程专业服务，量身定制保障方案
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="bx_container advantage_bx_container"
        style="padding-top:100px;"
      >
        <div class="bx_container_title">
          <div class="main_title">服务优势</div>
          <div class="sub_title">
            科学量化保障缺口，提供一站式规划服务
          </div>
        </div>

        <div class="bx_container_content">
          <div class="advantages_new">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide>
                <div class="advantage_item">
                  <img
                    src="@/assets/images/version/advantage5.png"
                    alt="专属顾问"
                  />
                  <div class="advantage_title">
                    <div class="main">专属顾问</div>
                    <div class="sub">
                      专业投保顾问团队，科普保险知识，在线1对1专业咨询，帮助用户做出正确判断
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage_item">
                  <img
                    src="@/assets/images/version/advantage6.png"
                    alt="量化缺口"
                  />
                  <div class="advantage_title">
                    <div class="main">量化缺口</div>
                    <div class="sub">
                      了解家庭基本情况，对历史保单进行分析，查漏补缺，评估家庭未来潜在风险
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage_item">
                  <img
                    src="@/assets/images/version/advantage7.png"
                    alt="定制方案"
                  />
                  <div class="advantage_title">
                    <div class="main">定制方案</div>
                    <div class="sub">
                      依托大数据、云计算和人工智能，精准匹配产品，至少节省30-50%保费
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage_item">
                  <img
                    src="@/assets/images/version/advantage8.png"
                    alt="投保指导"
                  />
                  <div class="advantage_title">
                    <div class="main">投保指导</div>
                    <div class="sub">
                      解读核心条款，告知理赔潜在风险，在线指导填写资料，有效投保不踩坑
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="advantage_item">
                  <img
                    src="@/assets/images/version/advantage9.png"
                    alt="理赔协助"
                  />
                  <div class="advantage_title">
                    <div class="main">理赔协助</div>
                    <div class="sub">
                      终身理赔协助，帮助客户省时省心省力，避免出现“理赔无门”
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
      <div class="bx_container" style="padding-top:100px;">
        <div class="bx_container_title">
          <div class="main_title">咨询流程说明</div>
          <div class="sub_title">
            全流程服务，一切为了用户体验
          </div>
        </div>
        <div class="bx_container_content">
          <div class="steps">
            <div class="step_item">
              <img
                src="@/assets/images/version/step1.png"
                class="step_icon"
                alt="保险咨询"
              />
              <div class="step_title">保险咨询</div>
            </div>
            <div class="step_split"></div>
            <div class="step_item">
              <img
                src="@/assets/images/version/step2.png"
                class="step_icon"
                alt="风险评估"
              />
              <div class="step_title">风险评估</div>
            </div>
            <div class="step_split"></div>
            <div class="step_item">
              <img
                src="@/assets/images/version/step3.png"
                class="step_icon"
                alt="方案定制"
              />
              <div class="step_title">方案定制</div>
            </div>
            <div class="step_split"></div>
            <div class="step_item">
              <img
                src="@/assets/images/version/step4.png"
                class="step_icon"
                alt="投保指导"
              />
              <div class="step_title">投保指导</div>
            </div>
            <div class="step_split"></div>
            <div class="step_item">
              <img
                src="@/assets/images/version/step5.png"
                class="step_icon"
                alt="理赔协助"
              />
              <div class="step_title">理赔协助</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <tools :type="pageType" />
    <Footer :type="pageType" />
    <adviser-qrcode-modal ref="qrcodeRef" />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Tools from "@/components/absoluteTools";
import AdviserQrcodeModal from "@/components/adviserQrcodeModal";
export default {
  name: "Consult",
  metaInfo() {
    return {
      title: "骆驼规划官网-润安国际保险-专业保险规划机构，省心省钱买对保险",
      keywords: "骆驼规划,保险方案,保险评测,保险理赔",
      description:
        "骆驼规划是一家专业中立的第三方保险规划平台，致力于让普通家庭也能享受到量身定制的保险规划服务，提供包括重疾险、医疗险、儿童险、寿险、意外险等在内的保险方案定制、风险评测、理赔协助、保险科普、保险评测等服务。"
    };
  },
  components: {
    Header,
    Footer,
    Tools,
    AdviserQrcodeModal
  },
  data() {
    return {
      pageType: 2,
      title: "",
      keywords: "",
      description: "",
      afterShow: false,
      url: "",
      servicePath:
        "https://m.luotuoguihua.com/servconfig/get/AL202101270000001",
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        // slidesPerGroup: 3,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      solution1: [
        {
          id: "0haIHWyO",
          adviserName: "海老师",
          adviserTitle: "资深保险规划师",
          praiseRate: "99.2%",
          serviceCount: "1779",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/782895_65uWJa1iQxyLlcr_1609900401/0",
          licenseNum: "26062000000080062020000679",
          adviserId: "P2020090900017",
          education: "金融保险专业本科",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/3c07f1be2a2e4aca984644181c09c8fd.png",
          cpAvatar:
            "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7BszLJOjVicGDoxW3cUbl39GtyFYAibNUgz5y9UtDZ9qpEVk3B8vTicRhxz0/0",
          workYear: "2",
          totalServiceCount: "3562"
        },
        {
          id: "joxpngtj",
          userName: "张凯丽",
          avatarUrl:
            "https://file23info.ppdai.com/69a7b38cb1ba4ed1b015ba76d1631c8f.png",
          adviserName: "张老师",
          adviserTitle: "保险规划师",
          praiseRate: "99.7%",
          serviceCount: "1760",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/937488_1MbEfoOrSEqnUIM_1616768018/0",
          licenseNum: "26062000000080062020001727",
          adviserId: "P2020120200003",
          education: "大学本科学历",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/dc16310621f34bf886e04a6ec5ff009e.png",
          cpAvatar:
            "https://file23info.ppdai.com/e305a0f523d94d62868c8f74a777e06c.png",
          workYear: "2",
          totalServiceCount: "3540",
          entryTime: "2020-12-02 17:07:05.00"
        },
        {
          id: "VFCd8VZB",
          avatarUrl:
            "https://file23info.ppdai.com/3dac74daeb7e44c48cc8c7fdf0aa5794.png",
          adviserName: "崔老师",
          adviserTitle: "保险规划师",
          praiseRate: "99.7%",
          serviceCount: "1838",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/637315_s6KAcGxGQ92p0Ss_1616768019/0",
          licenseNum: "26062000000080062020001786",
          adviserId: "P2020120200004",
          education: "大学本科学历",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/1965b400038c478f85e1cc5a3f2409bd.png",
          cpAvatar:
            "https://file23info.ppdai.com/7768f599cd984370b34074a7019653bc.png",
          workYear: "2",
          totalServiceCount: "3605",
          entryTime: "2020-12-02 17:25:46.00"
        }
      ],
      solution2: [
        {
          id: "2qb5iM3G",
          avatarUrl:
            "https://file23info.ppdai.com/8c869fb561304cf2bf266986c9fb91e9.png",
          adviserName: "朱老师",
          adviserTitle: "资深保险规划师",
          praiseRate: "99.5%",
          serviceCount: "1744",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/408806_P7VPDyVwT-m0y4i_1616767984/0",
          licenseNum: "26062000000080062020000759",
          adviserId: "P2020090900009",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/31351783ed4c4ae6957f012d51c5c6ef.png",
          cpAvatar:
            "https://file23info.ppdai.com/74ccbeadb4cb4338908173f06bed94bd.png",
          workYear: "2",
          totalServiceCount: "3540",
          entryTime: "2020-09-09 15:45:32.00"
        },
        {
          id: "cYImuWPm",
          adviserName: "朱老师",
          adviserTitle: "资深保险规划师",
          praiseRate: "99.9%",
          serviceCount: "1763",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/57952_XVtptk7lTdemTcQ_1609900377/0",
          licenseNum: "26062000000080062020000381",
          adviserId: "P2020080400003",
          education: "金融保险专业本科",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/fc7941f765fc4b5f89eab6beeb816121.png",
          cpAvatar:
            "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs8AEiawXIR61O9yibCU3O2S9EmY0EY22FGFOUzEHibqKhYz6bpO3CiaBjW4/0",
          workYear: "2",
          totalServiceCount: "3660"
        },
        {
          id: "ohd1ls2r",
          userName: "韩佳润",
          avatarUrl:
            "https://file23info.ppdai.com/02e2ae509f174c81be03d41578ea4eaa.png",
          adviserName: "韩老师",
          adviserTitle: "资深保险规划师",
          praiseRate: "99.2%",
          serviceCount: "1816",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/504311_5Hwd25W7RSyruGb_1616768004/0",
          licenseNum: "26062000000080062020001093",
          adviserId: "P2020102000011",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/0307958dcdc44856a5a4597a24d6c1ce.png",
          cpAvatar:
            "https://file23info.ppdai.com/7491177d1ffe4bbb9013c7c9dca939b5.png",
          workYear: "2",
          totalServiceCount: "3623",
          entryTime: "2020-10-20 14:38:07.00"
        }
      ],
      solution3: [
        {
          id: "3TzemDV7",
          avatarUrl:
            "https://file23info.ppdai.com/17fde70d027746458e49e4483235a9c2.png",
          adviserName: "梅老师",
          adviserTitle: "资深保险规划师",
          praiseRate: "99.7%",
          serviceCount: "2817",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/856965_fcaJpPP4QVqIgnK_1616767973/0",
          licenseNum: "26062000000080062020000437",
          adviserId: "P2020082600005",
          education: "大学本科学历",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/6cb09751c46c470a996049eec293203d.png",
          cpAvatar:
            "https://file23info.ppdai.com/5af716bcf87c42bdbcdfe34daf9630ce.png",
          workYear: "2",
          totalServiceCount: "3585",
          entryTime: "2020-08-26 21:32:32.00"
        },
        {
          id: "IZCLG92I",
          adviserName: "Lily老师",
          adviserTitle: "高级保险规划师",
          praiseRate: "99.1%",
          serviceCount: "1837",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/785109_maN9rYYaTsKEUmR_1609900371/0",
          licenseNum: "26062000000080062020000025",
          adviserId: "P2020031200002",
          education: "金融保险专业本科",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/818b861aea2a4b2d8b6dd619641119b0.png",
          cpAvatar:
            "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7BsztoQ1BqudIJdo8o6ibIjcTiadkeTc9zcwlBPkFWoUib8fdkoBiaW0UZrRU/0",
          workYear: "2",
          totalServiceCount: "3515"
        },
        {
          id: "q6MTy1Q3",
          avatarUrl:
            "https://file23info.ppdai.com/30a52d3559c5455b904ea936e19246f4.png",
          adviserName: "丁老师",
          adviserTitle: "保险规划师",
          praiseRate: "99.9%",
          serviceCount: "1835",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/587433_MfNwC8IbR5ain1O_1616768013/0",
          licenseNum: "26062000000080062020001399",
          adviserId: "P2020110400017",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/42a2616caf6c445a88491eebcd8cdc92.png",
          cpAvatar:
            "https://file23info.ppdai.com/d1156d3ba5fc48f3bf2f9140f1a24693.png",
          workYear: "2",
          totalServiceCount: "3620",
          entryTime: "2020-11-04 15:31:26.00"
        }
      ],
      solution4: [
        {
          id: "1ipv6iqh",
          userName: "狄玫希",
          avatarUrl:
            "https://file23info.ppdai.com/4ebd14ccde0a4275809c08301c18b46b.png",
          adviserName: "狄老师",
          adviserTitle: "保险规划师",
          praiseRate: "99.1%",
          serviceCount: "1753",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/683944_rrbNesozSMm-hWS_1616768014/0",
          licenseNum: "26062000000080062020001518",
          adviserId: "P2020110400022",
          education: "大学本科学历",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/7880e5270d4047b1ad11f81a254fc9fb.png",
          cpAvatar:
            "https://file23info.ppdai.com/b7f7d161eda6464db9b8700760b01b33.png",
          workYear: "2",
          totalServiceCount: "3622",
          entryTime: "2020-11-04 15:43:09.00"
        },
        {
          id: "IVnEgHFX",
          adviserName: "徐老师",
          adviserTitle: "资深保险规划师",
          praiseRate: "99.7%",
          serviceCount: "1783",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/623517_AgQoSmehQfGAJBh_1609900395/0",
          licenseNum: "26062000000080062020000767",
          adviserId: "P2020090900004",
          education: "金融保险专业本科",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/968c9659cb2548399069db8282fa95fc.png",
          cpAvatar:
            "http://wework.qpic.cn/wwhead/nMl9ssowtibVGyrmvBiaibzDhjJ77kfPLBMG5htUJzfMOKZo8p1YQEia3KWtHJlwBEnicPEFluGuuGb4/0",
          workYear: "2",
          totalServiceCount: "3547"
        },
        {
          id: "379s0hwk",
          userName: "孔令潇",
          avatarUrl:
            "https://file23info.ppdai.com/6a929991949c4104a5860cf5f5a041d1.png",
          adviserName: "孔老师",
          adviserTitle: "保险规划师",
          praiseRate: "99.3%",
          serviceCount: "1748",
          qrcodeUrl:
            "https://wework.qpic.cn/wwpic/505878_40xABwM3T9-OeZK_1616768034/0",
          licenseNum: "26062000000080062021000184",
          adviserId: "P2021011300004",
          identification: "互联网保险从业认证,年度新锐服务之星",
          bustPhoto:
            "https://file23info.ppdai.com/db01a8265628412c928f9a40c68f9e8d.png",
          cpAvatar:
            "https://file23info.ppdai.com/4f08bf03dd7f432c8bcc7bf328b1ecff.png",
          workYear: "2",
          totalServiceCount: "3625",
          entryTime: "2021-01-13 19:26:19.00"
        }
      ]
    };
  },
  methods: {}
};
</script>
